import { KYMW2100Model } from '../kymw2100.model';
import { SearchConditionOfOrderNumModel } from '../vo/search-condition-of-order-num.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

/**
 * 一括付番を行うサービス
 *
 * @export UpdateIndiscriminatelyOrderNumService
 * @class UpdateIndiscriminatelyOrderNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateIndiscriminatelyOrderNumService extends PlessJsonResponderSub<any> {

  private model: KYMW2100Model;
  private vo = new SearchConditionOfOrderNumModel();

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateIndiscriminatelyOrderNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Rec: {
          condition: {
            OrderCode: this.vo.OrderCode,
            MediumType: this.vo.MediumType,
            CoopCode: this.vo.CoopCode,
            AvailableOrderNumFrom: this.vo.AvailableOrderNumFrom,
            AvailableOrderNumTo: this.vo.AvailableOrderNumTo,
            UnnumberedOnlyFlg: this.vo.UnnumberedOnlyFlg
          }
        }
      }
    });
  }

  /**
   * API呼び出しin
   *
   * @param model
   * @memberof UpdateIndiscriminatelyOrderNumService
   */
  execute(model: KYMW2100Model, vo: SearchConditionOfOrderNumModel): void {
    this.model = model;
    this.vo = vo;
    this.send('updateIndiscriminatelyOrderNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateIndiscriminatelyOrderNumService
   */
  success(data: any): void {
    if (data !== null) {
      // 注文コード差分フラグの検証
      // 注文コード差分フラグが1：差分ありのデータをリストに格納
      const diffFlgOnOrderNumList = data.filter(_ => _.OrderNumPreBundleDiffFlg === "1").map(_ => _.OrderNum);
      // 注文コード差分フラグが1：差分ありのデータが1件以上の場合
      if (!PlessViewUtilsSub.isEmptyArray(diffFlgOnOrderNumList)) {
        // 差分フラグが1のデータに紐づく注文コードをカンマ区切りで結合し、警告ダイアログを表示する。
        const orderNumString = diffFlgOnOrderNumList.join(",");
        this.dialogService.openAlertGetMessage('E0647', [orderNumString], (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes_Error) {
            // データグリッド「注文コード一覧」を更新
            this.model.updateOrderNumList(data, this.vo);
            // ボタン「設定」、「リセット」の活性状態を設定する
            this.model.kymw2100Component.setSetButtonEnabled();
            //  企画ロックを解除する
            this.model.kymw2100Component.releaseLockInfoCatalog();
          }
        });
      } else {
        // データグリッド「注文コード一覧」を更新
        this.model.updateOrderNumList(data, this.vo);
        // ボタン「設定」、「リセット」の活性状態を設定する
        this.model.kymw2100Component.setSetButtonEnabled();
        //  企画ロックを解除する
        this.model.kymw2100Component.releaseLockInfoCatalog();
      }
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof UpdateIndiscriminatelyOrderNumService
   */
  public plessErrorHandler(errList: Object): void {
    //  企画ロックを解除する
    this.model.kymw2100Component.releaseLockInfoCatalog();
    // 標準処理を続行
    super.plessErrorHandler(errList);
  }

  /**
   * システムエラー時のメソッド
   * @param errList サーバ受信データ
   *  機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public systemErrorHandler(errList: Object): void {
    //  企画ロックを解除する
    this.model.kymw2100Component.releaseLockInfoCatalog();
    // 標準処理を続行
    super.systemErrorHandler(errList);
  }
}
